import { matchPath } from "react-router";

export const SCOPE_SWITCH_STATE = { scopeSwitch: true } as const;

export const isScopeSwitchNavigation = (state: unknown): boolean =>
	typeof state === "object" &&
	state !== null &&
	"scopeSwitch" in state &&
	state.scopeSwitch === true;

export type UrlScope = {
	companyDomainId: string;
	legalEntityId: string | undefined;
};

export const scopeForPathname = (pathname: string): UrlScope | undefined => {
	const match = matchPath(
		{ path: "/company-domains/:companyDomainId/*", end: false },
		pathname,
	);
	const companyDomainId = match?.params.companyDomainId;
	if (!companyDomainId) return undefined;

	const entityMatch = matchPath(
		{
			path: "/company-domains/:companyDomainId/legal-entities/:legalEntityId/*",
			end: false,
		},
		pathname,
	);
	const segment = entityMatch?.params.legalEntityId;
	// WHY digits only: sibling routes such as /legal-entities/hierarchy sit where an id does.
	const legalEntityId =
		segment !== undefined && /^\d+$/.test(segment) ? segment : undefined;
	return {
		companyDomainId,
		legalEntityId,
	};
};

// WHY URL to URL: the pickers show the URL, and the remembered scope outlives domain-only pages.
export const scopeChangeNeedsConfirmation = ({
	fromPathname,
	toPathname,
}: {
	fromPathname: string;
	toPathname: string;
}): UrlScope | undefined => {
	const from = scopeForPathname(fromPathname);
	const to = scopeForPathname(toPathname);
	if (!from || !to) return undefined;

	const movesDomain = from.companyDomainId !== to.companyDomainId;
	const movesCompany = from.legalEntityId !== to.legalEntityId;
	return movesDomain || movesCompany ? to : undefined;
};
